import { colorCss } from "./colorCss";

const COLOR_OFFSET = 4;
const COLOR_FLOATS = 4;
const WIDTH_OFFSET = COLOR_OFFSET + COLOR_FLOATS;
// lineRenderer caps the ends by half the width for the Line chart, a square cap does the same
const SQUARE_CAP_RATIO = 0.5;

const isSameStyle = (instances, offset, previousOffset, floatsPerInstance) => {
  if (previousOffset < 0) return false;

  for (let index = COLOR_OFFSET; index < floatsPerInstance; index += 1) {
    if (instances[offset + index] !== instances[previousOffset + index]) return false;
  }

  return true;
};

/**
 * Canvas 2D version of lineRenderer.draw: the same segments, colours and
 * widths in device pixels. Segments of one style go into one path; segments
 * outside the canvas and gaps (width 0, e.g. an indicator without a value) are skipped.
 *
 * @param {CanvasRenderingContext2D} context
 * @param {Float32Array} instances - [x0, y0, x1, y1, r, g, b, a, width] per segment
 * @param {number} floatsPerInstance
 * @param {object} params - see lineRenderer.draw
 */
export const paintLines = (
  context,
  instances,
  floatsPerInstance,
  { viewport, xTransform, yTransform, widthScale = 1, capRatio = 0 },
) => {
  const [xScale, xOffset] = xTransform;
  const [yScale, yOffset] = yTransform;
  const [viewWidth] = viewport;
  let styleOffset = -1;

  context.lineCap = capRatio >= SQUARE_CAP_RATIO ? "square" : "butt";
  context.beginPath();

  for (let offset = 0; offset < instances.length; offset += floatsPerInstance) {
    const fromX = instances[offset] * xScale + xOffset;
    const toX = instances[offset + 2] * xScale + xOffset;

    if (Math.max(fromX, toX) < 0 || Math.min(fromX, toX) > viewWidth) continue;
    if (instances[offset + WIDTH_OFFSET] === 0) continue;

    if (!isSameStyle(instances, offset, styleOffset, floatsPerInstance)) {
      context.stroke();
      context.beginPath();
      context.strokeStyle = colorCss(instances, offset + COLOR_OFFSET);
      context.lineWidth = instances[offset + WIDTH_OFFSET] * widthScale;
      styleOffset = offset;
    }

    context.moveTo(fromX, instances[offset + 1] * yScale + yOffset);
    context.lineTo(toX, instances[offset + 3] * yScale + yOffset);
  }

  context.stroke();
};
